"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _experimentActionKeys = _interopRequireDefault(require("./experimentActionKeys"));

var _experimentActionKeys2 = _interopRequireDefault(require("../experimentActionKeys"));

var _createReducer2 = _interopRequireDefault(require("../../createReducer"));

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initalState = {
  experiments: {},
  variations: {},
  isLoading: {}
};

var _default = (0, _createReducer2.default)(initalState, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.VARIATION_DETERMINED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    variations: _objectSpread(_objectSpread({}, state.variations), {}, (0, _defineProperty2.default)({}, action.payload.key, _objectSpread({}, action.payload)))
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.GET_TARGET_OFFER_START, function (state, action) {
  var name = (0, _get2.default)(action, 'meta.name');
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: _objectSpread(_objectSpread({}, state.isLoading), {}, (0, _defineProperty2.default)({}, name, true))
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.GET_TARGET_OFFER_ERROR, function (state, action) {
  var name = (0, _get2.default)(action, 'meta.name');
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: _objectSpread(_objectSpread({}, state.isLoading), {}, (0, _defineProperty2.default)({}, name, false))
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys.default.GET_TARGET_OFFER_SUCCESS, function (state, action) {
  var name = (0, _get2.default)(action, 'meta.name');
  var offers = (0, _get2.default)(action, 'payload', []);
  var offerResult = (0, _find2.default)(offers, function (offer) {
    return offer.action === 'setJson';
  });

  if (offerResult) {
    var jsonPayload = (0, _get2.default)(offerResult, 'content[0]', {});
    return _objectSpread(_objectSpread({}, state), {}, {
      experiments: _objectSpread(_objectSpread({}, state.experiments), {}, (0, _defineProperty2.default)({}, name, jsonPayload)),
      isLoading: _objectSpread(_objectSpread({}, state.isLoading), {}, (0, _defineProperty2.default)({}, name, false))
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: _objectSpread(_objectSpread({}, state.isLoading), {}, (0, _defineProperty2.default)({}, name, false))
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys2.default.SET_EXPERIMENTS, function (state, action) {
  var newExperiments = Object.keys(action.payload).reduce(function (acc, key) {
    var testPayload = action.payload[key];
    var existingExperiment = (0, _get2.default)(state, "experiments.".concat(key), {});

    if (typeof testPayload === 'boolean') {
      return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, key, _objectSpread(_objectSpread({}, existingExperiment), {}, {
        enabled: testPayload
      })));
    } else {
      return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, key, _objectSpread(_objectSpread({}, existingExperiment), testPayload)));
    }
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    experiments: _objectSpread(_objectSpread({}, state.experiments), newExperiments)
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys2.default.RESET_EXPERIMENTS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    experiments: {}
  });
}), (0, _defineProperty2.default)(_createReducer, _experimentActionKeys2.default.GET_FEATURE_FLAGS_SUCCESS, function (state, action) {
  var gatewayFeatureFlags = (0, _get2.default)(action, 'payload.body.flags', []);
  var stbeFeatureFlags = (0, _get2.default)(action, 'payload.body.featureFlags', []);
  var stbeExperiments = stbeFeatureFlags.reduce(function (acc, flag) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, flag, {
      enabled: true
    }));
  }, {});
  var gatewayExperiments = gatewayFeatureFlags.reduce(function (acc, flag) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, flag.key, {
      enabled: flag.value
    }));
  }, {}); // spread state.experiments last in case we had a experiment be set before api call resolved

  return _objectSpread(_objectSpread({}, state), {}, {
    experiments: _objectSpread(_objectSpread(_objectSpread({}, stbeExperiments), gatewayExperiments), state.experiments)
  });
}), _createReducer), false);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/v2/experimentReducer.js
// module id = 4340
// module chunks = 25